import { ProjectsReducerCreator } from '../types';

const clearGroupErrorReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state) => {
    state.groupError = '';
  });
};

export default clearGroupErrorReducer;
